// src/app/layout/SidebarUserSection.tsx
import { LogOut } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { useAuthStore } from '@vanialabs/core-auth';

// User/logout block. Extracted so the logout flow (clear localStorage
// key, clear auth store, redirect to /login) exists in exactly one
// place and is shared by the desktop Sidebar and the MobileNavDrawer —
// no duplicated auth logic between the two nav surfaces.

interface SidebarUserSectionProps {
  /** Called right before navigating to /login, e.g. to close the mobile drawer. */
  onAfterLogout?: () => void;
}

export function SidebarUserSection({ onAfterLogout }: SidebarUserSectionProps) {
  const user = useAuthStore((state) => state.session?.user);
  const navigate = useNavigate();

  if (!user) return null;

  const userName = user.name?.trim() || user.mobile;
  const userInitial = userName.charAt(0).toUpperCase();

  const handleLogout = () => {
    localStorage.removeItem('vania-auth-session');
    useAuthStore.getState().clearSession();
    onAfterLogout?.();
    navigate('/login', { replace: true });
  };

  return (
    <div className="flex items-center gap-2.5 border-t border-[var(--vania-colors-border-subtle,rgba(255,255,255,0.08))] px-4 py-3">
      {user.avatarUrl ? (
        <img
          src={user.avatarUrl}
          alt=""
          className="h-8 w-8 shrink-0 rounded-full object-cover"
        />
      ) : (
        <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-[var(--vania-colors-surface-secondary,rgba(255,255,255,0.08))] text-xs font-semibold text-[var(--vania-colors-text-primary,#f5f6fa)]">
          {userInitial}
        </span>
      )}
      <span className="min-w-0 flex-1 truncate text-sm text-[var(--vania-colors-text-secondary,#a3aab8)]">
        {userName}
      </span>
      <button
        type="button"
        onClick={handleLogout}
        title="خروج"
        aria-label="خروج"
        className="flex h-8 w-8 shrink-0 items-center justify-center rounded-lg text-[var(--vania-colors-text-secondary,#a3aab8)] transition-colors hover:bg-[var(--vania-colors-surface-secondary,rgba(255,255,255,0.06))] hover:text-[var(--vania-colors-danger,#f87171)]"
      >
        <LogOut size={16} strokeWidth={2.2} />
      </button>
    </div>
  );
}
